import { render } from "./ActivationSuccess.page.vue?vue&type=template&id=151da566"
import script from "./ActivationSuccess.page.vue?vue&type=script&lang=js"
export * from "./ActivationSuccess.page.vue?vue&type=script&lang=js"

import "./ActivationSuccess.page.vue?vue&type=style&index=0&id=151da566&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QFooter,QBtn});
